module.exports = __webpack_public_path__ + "img/fossil2Img2.83271bac.jpg";